import React, { useEffect, useState} from "react";
import styled from 'styled-components';
import { useLocation, useNavigate } from "react-router-dom";

import {ethers} from "ethers";
import { createProvider,  } from "../../constants/EIP1193";

const OffRampPage = (props: any) => {
    
    const navigate: any = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const address = searchParams.get("address");
    const email = searchParams.get("email");
    

    const setAndCheckOnIframeLoad = ()=> {
        // a set interval that checks till iframe is loaded
        // then sets the ethereum property
        // and then stops
        
        // provider.isGlip = true;
        // const newProvider = new ethers.providers.Web3Provider(provider);
        // console.log('newProvider', newProvider);
        // provider.provider.
        // window.parent.web3.isGlip
        // get iframe of onMetawidget
    }

    const changeSrcOfIframeWidget = () => {
        const iframe:any = document.getElementById('onMetaWidgetId') as HTMLIFrameElement;
        const currentSrc = iframe.src;
        const newDomain = 'glip.gg/onmeta';
        const regex = /^(.*\/\/[^\/]+)\//;
        const match = currentSrc.match(regex);
        console.log('match', match);
        if (match) {
            const oldDomain = match[0];
            const newSrc = currentSrc.replace(oldDomain, `//${newDomain}`);
            iframe.src = newSrc;
            iframe.addEventListener('load', () => {
                const {signer, provider}: any = (
                    createProvider("137"));

                provider.isGlip = true;
                //@ts-ignore
                (window as any).ethereum = provider;
                (window as any).web3 = provider;
                
                iframe.contentWindow.ethereum = (window as any).ethereum;
                //iframe.contentWindow.ethereum.isGlip = true;
                //iframe.contentWindow.web3.isGlip = true;
            });
        }
    }
    
    const initializeOnMetaWidget = async () => {
        let createWidget = new (window as any).onMetaWidget({
            elementId: "widget",
            apiKey: "69704437-a0f7-446c-9dbd-921315b4b37f",
            //apiKey:"25df82e1-d4d3-4519-8b9d-35d2c9a31a17",
            userEmail: email,
            offRamp: "enabled",
            onRamp: "disabled",
            walletAddress: address
        });
        //change src
        await createWidget.init();
        changeSrcOfIframeWidget();
        setAndCheckOnIframeLoad();
        //createWidget.on(eventType, callbackFn); // this m
    }
    
    useEffect(()=>{
        initializeOnMetaWidget();
    },[]);
    
    return  (
        <div style={{
            display:'flex',
            height: '100%',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
          <div id="widget"></div>
        </div>
    )
}

export default OffRampPage;
